import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { BaseIcon, BaseText } from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import {
  OrderDetailsHero,
  OrderDetailsContent,
  ProductDetailsModal,
  RedemptionModal
} from './components';
import {
  IOrderItem,
  IOrderProduct,
  EOrderStatus
} from '@/modules/wealth/services/portfolio-orders';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  isOpen: boolean;
  orderItem: IOrderItem | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetailsSheet',
  props: {
    isOpen: { type: Boolean },
    orderItem: null
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  orderItem: IOrderItem | null;
};



const isProductDetailsModalOpen = ref(false);
const selectedProduct = ref<IOrderProduct | null>(null);
const showAlert = ref(true);
const isRedemptionDetailsOpen = ref(false);

const alertDetails = computed(() => {
  return props.orderItem?.details.alert;
});

const shouldShowAlert = computed(() => {
  return Boolean(
    alertDetails.value &&
      showAlert.value &&
      props.orderItem?.details.header.status !== EOrderStatus.CANCELED
  );
});

function handleProductClick(product: IOrderProduct) {
  selectedProduct.value = product;
  isProductDetailsModalOpen.value = true;
}

function closeProductDetailsModal() {
  isProductDetailsModalOpen.value = false;
  selectedProduct.value = null;
}

return { __sfc: true,props, isProductDetailsModalOpen, selectedProduct, showAlert, isRedemptionDetailsOpen, alertDetails, shouldShowAlert, handleProductClick, closeProductDetailsModal, BaseIcon, BaseText, SideSheet, BackButton, OrderDetailsHero, OrderDetailsContent, ProductDetailsModal, RedemptionModal, NebraskaColors }
}

})